<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 列表数据 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary" @click="setAdd()" v-if="isShow">上传应用</el-button>
                </div>
            </div>

             <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="applyVersion"  label="应用类型"  :show-overflow-tooltip="true" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.applyType == 2">补丁</div>
                        <div v-else-if="scope.row.applyType == 1">全量</div>
                    </template>
                </el-table-column>
                <el-table-column prop="applyVersion"  label="应用版本"  :show-overflow-tooltip="true" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.applyStatus == 2 ">
                            {{scope.row.applyVersion}}<span style="color:red;">(此版本正在用)</span>
                        </div>
                        <div v-else>
                            {{scope.row.applyVersion}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="fileSize" label="应用大小(字节)" :show-overflow-tooltip="true"  width="110"></el-table-column>
                <el-table-column prop="remark" label="版权说明"></el-table-column>
                <el-table-column prop="gmtCreate" label="创建时间" width="140"></el-table-column>
                <el-table-column prop="" label="下线时间" width="140">
                    <template slot-scope="scope">
                        <div v-if="scope.row.gmtModified != '' && scope.row.gmtModified != null">
                            {{scope.row.gmtModified}}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="140">
                    <template slot-scope="scope">
                        <div v-if="scope.row.applyStatus == 1 && isShow">
                           <el-button  @click.native.prevent="releaseVersion(scope.row.id,2)"
                                        type="primary">
                                        发布
                            </el-button>
                            <el-button  @click.native.prevent="del(scope.row.id)" style="margin-top:5px;"
                                type="danger">
                                删除
                            </el-button>
                        </div>
                        <div v-else-if="scope.row.applyStatus == 3 && isShow">
                            <el-button  @click.native.prevent="rollBackVersion(scope.row.id,2)"
                                        type="primary">
                                        回滚到此版本
                            </el-button>
                        </div>
                        <div v-else-if="scope.row.applyStatus == 2">
                            <el-button  type="danger" @click.native.prevent="offApply(scope.row.id)" v-if="isShow">下架</el-button>
                            <el-button type="primary" style="margin-top:5px;">
                                <a :href="scope.row.applyUrl" target="_blank" v-if="scope.row.applyType == 2">下载</a>
                                <a :href="scope.row.fullApplyUrl" target="_blank" v-if="scope.row.applyType == 1">下载</a>
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
    </div>
</template>

<script>
    import http from '../../../common/http';
    import add from './AddAndroid.vue';

    export default {
        name:"ApplyAndroidManage",
        data(){
            return{
                menuName:"",
                addVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    applyStatus:"",
                    deptId:""
                },
                isShow:false,
                depts:[],
                data:[]
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
            // 用户信息
            let userinfo =JSON.parse(sessionStorage.getItem('userinfo'));
            // 如果id为1的话，表示管理员，管理才能上传或者回滚此应用及拷贝
            if(userinfo.id == 1){
                this.isShow=true;
            }else{
                this.isShow=false;
            }
        },
        components: {
            add
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list;
                       if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                let url  = this.applyManageListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    type: 2, // 应用类型（1-桌面应用，2-Android应用，3-苹果应用）
                };       
                // console.log(JSON.stringify(data))
                // return;
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total=res.data.total; 

                       // 不是管理员进来，只能看到一条已发布的数据
                       if(!this.isShow){   
                            let release=[];
                            for(let i=0;i<this.data.length;i++){
                                let v=this.data[i];
                                if(v.applyStatus == 2){
                                    release.push(v);
                                }
                            }
                            this.data=release;
                        }

                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{

                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init(this.form.deptId);
                })
            },
            //删除
            del(id){
                this.form.id =id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.applyManageRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            releaseVersion(id,applyStatus){
                let msg="发布此版本，将覆盖正在使用的版本，是否继续？";
                this.form.id=id;
                this.form.applyStatus=applyStatus;
                this.$commonFn.showConfirm2(msg,this.updateSuccess);
            },
            rollBackVersion(id,applyStatus){
                let msg="回滚此版本，将覆盖正在使用的版本，是否继续？";
                this.form.id=id;
                this.form.applyStatus=applyStatus;
                this.$commonFn.showConfirm2(msg,this.updateSuccess);
            },
            updateSuccess(){
                let url = this.applyManageUpdateUrl;
                let data = {
                    id:this.form.id,
                    applyStatus:this.form.applyStatus,
                    type: 2, // 应用类型（1-桌面应用，2-Android应用，3-苹果应用）
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            offApply(id){
                let msg="确定下架此版本吗？";
                this.form.id=id;
                this.$commonFn.showConfirm2(msg,this.offApplySuccess);
            },
            offApplySuccess(){
                let url = this.applyManageOffUrl;
                let data = {
                    id:this.form.id,
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/apply/ApplyAndroidManage.vue